import React from 'react';
import { cn } from '@/utils/cn';

interface BentoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  iconPath: string;
  backgroundColor?: string;
}

export const BentoCard = ({
  title,
  description,
  iconPath,
  backgroundColor = "#f2f6ff",
  className,
  ...props
}: BentoCardProps) => {
  return (
    <div
      className={cn("rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow", className)}
      style={{ backgroundColor }}
      {...props}
    >
      <h3 className="text-xl font-bold text-gray-900 mb-4">{title}</h3>
      <p className="text-gray-600 mb-6">{description}</p>
      <div className="h-24 flex items-end">
        <img
          src={iconPath}
          alt={title}
          className="h-16 w-16 text-primary-600"
        />
      </div>
    </div>
  );
};

export default BentoCard;